module.exports = __webpack_public_path__ + "media/images/illustrations/protection_plan_premium_small-51643a53e51844591719a790727b7206.svg";